/**
 * @see /client/containers/MyEGiftCards/index.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../components/Button';

const StyledValue = styled.div`
  text-align:left;
  ${Button}{
    margin-top:10px;
  }
`;

/**
 * @requires slug for enabling buy again button
 */
function Value(props) {
  const { data } = props;
  return (
    <StyledValue>
      &#8377;&nbsp;{data.value}<br />
      {/* <Button type="primary">Buy again</Button> */}
    </StyledValue>
  );
}

Value.propTypes = {
  data: PropTypes.object,
};
export default Value;



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/value.js